<script lang="ts">
export const truncatedTextTooltipUi = {
	content: 'h-auto max-w-100 max-h-60 items-start overflow-auto select-text',
	text: 'w-full min-w-0 overflow-visible text-clip whitespace-pre-wrap break-words',
};
</script>

<script setup lang="ts">
import { useRafFn, useResizeObserver } from '@vueuse/core';
import { onMounted, useTemplateRef, watch } from 'vue';
import DTooltip from '#layers/ui/components/Tooltip.vue';
import { useTruncation } from '#layers/ui/composables/use-truncation';

interface Props {
	text: string;
}

const { text } = defineProps<Props>();

const contentRef = useTemplateRef<HTMLElement>('content');
const { isTruncated, measure } = useTruncation(contentRef);

const { resume: scheduleMeasure } = useRafFn(measure, { immediate: false, once: true });

onMounted(() => {
	scheduleMeasure();
	// Web fonts change text width once loaded.
	document.fonts?.ready.then(scheduleMeasure);
});

watch(() => text, () => scheduleMeasure());

useResizeObserver(contentRef, scheduleMeasure);
</script>

<template>
	<DTooltip :text :ui="truncatedTextTooltipUi" :disabled="!isTruncated || !text">
		<span
			ref="content"
			class="block truncate"
			:tabindex="isTruncated && text ? 0 : undefined"
		>
			{{ text }}
		</span>
	</DTooltip>
</template>
